import humanizeDuration from "humanize-duration";

const humanizer = humanizeDuration.humanizer();
humanizer.languages.short_en = {
    y: () => 'y',
    mo: () => 'mo',
    w: () => 'w',
    d: () => 'd',
    h: () => 'h',
    m: () => 'm',
    s: () => 's',
    ms: () => 'ms'
};
humanizer.languages.short_pt = {
    y: () => 'a',
    mo: () => 'm',
    w: () => 's',
    d: () => 'd',
    h: () => 'h',
    m: () => 'm',
    s: () => 's',
    ms: () => 'ms'
};

const displayConfig = {
    serialComma: false,
    spacer: '',
    round: true,
    largest: 2,
    language: "en"
};

let DurationFormatter = {
    format(time, shortLabel) {
        if(shortLabel) {
            return humanizer(time, {...displayConfig, language: 'short_' + displayConfig.language});
        } else {
            return humanizer(time, displayConfig);
        }
    }
};

export default DurationFormatter;